<template>
  <div class="navbar">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <div class="project-info">
      <el-button
        type="text"
        style="text-transform: uppercase"
        v-if="company_name"
        @click="superRole ? $router.push(`/company/info/${company_uid}`) : $router.push(`/dashboard`)"
        >{{ company_name }}</el-button
      >
      <div class="header-search">
        <el-input v-model="search_value" @keyup.enter.native="search()" size="mini">
          <el-select v-model="search_by" slot="prepend" placeholder="Search by"  size="mini">
            <el-option label="BankholderID" value="bankholderid"></el-option>
            <el-option label="Member Code" value="membercode"></el-option>
            <el-option label="Account Number" value="accountnumber"></el-option>
            <el-option label="Email" value="email"></el-option>
            <el-option label="SEPA IBAN" value="iban"></el-option>
            <el-option label="SWIFT IBAN" value="iban_inter"></el-option>
            <el-option label="Telephone" value="telephone"></el-option>
            <el-option label="EnduserID" value="enduserid"></el-option>
            <el-option label="LedgerID" value="ledgerid"></el-option>
          </el-select>
          <el-button
           class="search-button"
            type="primary"
            slot="append"
            icon="el-icon-search"
            @click="search()"
             size="mini"
          ></el-button>
        </el-input>
      </div>
    </div>

    <div class="right-menu">
      <div class="user-name">{{ `${name} (${role})` }}</div>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img :src="require('@/assets/Lock-icon.png')" class="user-avatar" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link to="/dashboard">
            <el-dropdown-item> Dashboard </el-dropdown-item>
          </router-link>
          <router-link to="/profile">
            <el-dropdown-item> Profile </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">Log Out</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="select-project" v-if="superRole">
      <el-select
        v-model="projectSelected"
        placeholder="Select Project"
        size="mini"
        @change="gotoProject()"
      >
        <el-option
          v-for="item in projectData"
          :key="item.uid"
          :label="item.project_name"
          :value="item.uid"
        >
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Hamburger from "@/components/Hamburger";
import { getProjectByCompany } from "@/api/project";

export default {
  components: {
    Hamburger,
  },
  computed: {
    ...mapGetters([
      "sidebar",
      "avatar",
      "name",
      "role",
      "user_company",
      "user_project",
      "company_name",
      "company_uid",
    ]),
    superRole() {
      return this.roleAuth([this.role.spadmin]);
    },
  },
  data() {
    return {
      projectData: [],
      projectSelected: "",
      search_by: "bankholderid",
      search_value: "",
    };
  },
  watch: {
    $route(from, to) {
      this.setActiveProject();
    },
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      await this.$store.dispatch("user/logout");
      this.$router.push(`/login`);
    },
    getProjectData() {
      if (this.user_company) {
        getProjectByCompany(this.user_company).then(({ result, data }) => {
          if (result) {
            this.projectData = data;
          }
        });
      }
    },
    gotoProject() {
      this.$router.push("/project/" + this.projectSelected);
    },

    setActiveProject() {
      const project_uid = this.$route.params.project_uid;
      if (project_uid && !this.superRole) {
        this.projectSelected = project_uid;
      }
    },

    search(){
      this.$router.push(`/search?search_by=${this.search_by}&search_value=${this.search_value}`);
    }
  },
  created() {
    this.getProjectData();
    this.setActiveProject();
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .project-info {
    display: inline-block;
    font-size: 14px;
    padding: 4px;
  }

  .select-project {
    display: block;
    float: right;
    margin-right: 10px;
    margin-top: 10px;
    width: 150px;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 10px;

      .avatar-wrapper {
        margin-top: 10px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 30px;
          height: 30px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }

    .user-name {
      display: inline-block;
      vertical-align: 10px;
      font-size: 12px;
      color: #606266;
      padding-right: 10px;
    }

  }
}
</style>
